export const editNavKey = {
    ADMIN: 'ADMIN',
    SRTR: 'SRTR',
    TAX: 'TAX',
    UNOS: 'UNOS',
    CENTER_DATA: 'CENTER-DATA',
    LAB: 'LAB',
    SERVICES: 'SERVICES',
    ACCEPTED_INSURANCE: 'ACCEPTED-INSURANCE',
    SEROLOGY_TESTS: 'SEROLOGY-TESTS',
    ANATOMY_PREFS: 'ANATOMY-PREFS',
    LEGAL_DOCUMENTS: 'LEGAL-DOCUMENTS',
    PACKAGING: 'PACKAGING'
};

export const navTabs = [
    { key: editNavKey.ADMIN, name: 'Admin' },
    { key: editNavKey.SRTR, name: 'SRTR Data (Admin Only)' },
    { key: editNavKey.TAX, name: 'Taxes (Admin Only)' },
    { key: editNavKey.UNOS, name: 'UNOS Data (Admin Only)' },
    { key: editNavKey.CENTER_DATA, name: 'Center Data' },
    { key: editNavKey.LAB, name: 'Lab Data' },
    { key: editNavKey.SERVICES, name: 'Services' },
    { key: editNavKey.ACCEPTED_INSURANCE, name: 'Accepted Insurance' },
    { key: editNavKey.SEROLOGY_TESTS, name: 'Serology Tests' },
    { key: editNavKey.ANATOMY_PREFS, name: 'Waitlist Anat' },
    { key: editNavKey.LEGAL_DOCUMENTS, name: 'Legal Documents' },
    { key: editNavKey.PACKAGING, name: 'Packaging' }
]